import { Component } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-disclosure',
  templateUrl: './disclosure.component.html',
  styleUrls: ['./disclosure.component.css']
})
export class DisclosureComponent {
  constructor(private router: Router) { }
} 